//# sourceMappingURL=my-day-labels.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-day-labels.interface.js
// module id = 1006
// module chunks = 0